import axiosInstance from "../../api/auth/axiosInstance";

export const passwordChangeusername = async (userName,encrypted,otp) => {
  const response = await axiosInstance.put(`/user-entity/change-password/${userName}`,{password:encrypted.cipherText,rasId:encrypted.keyId,otp:otp},
    {headers: { authType: "PreLogin"}}
  );
  console.log("Forget Service Response:", response.data);
  return response;
};
export const sendOTPUsername = async (userName) => {
  const response = await axiosInstance.post(`/user-entity/send-otp/${userName}`,null,
    {headers: { authType: "PreLogin"}}
  );
  console.log("Forget Service Response:", response.data);
  return response;
};